import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import {
    CountriesService,
    CompanyWorker,
    ContractorResource,
} from '@icc/b2b/shared';
import { ConfigService } from '@icc/shared';
import { DialogRef, DIALOG_DATA } from '@icc/ui';
import { Subscription } from 'rxjs';

@Component({
    selector: 'icc-seller-dialog',
    templateUrl: './seller-dialog.component.html',
    styleUrls: ['./seller-dialog.component.scss'],
})
export class SellerDialogComponent implements OnInit {
    private subscriptions: Subscription[] = [];

    sellerWorkerId = null;
    sellerResourceId = null;
    deliveryAddressId = null;

    workers: CompanyWorker[] = [];
    resourceDeliveryAddresses: any[] = [];

    constructor(
        private fb: UntypedFormBuilder,
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            resourceId: number;
            deliveryAddressId: number;
            workers: CompanyWorker[];
            seller: any;
            sellerWorker: CompanyWorker;
            resources: ContractorResource[];
            side: 'seller' | 'buyer';
            canQuotesSellerChange: boolean;
        },
        private configService: ConfigService,
        private countriesService: CountriesService
    ) {



    }

    ngOnInit(): void {
        this.sellerWorkerId = String(this.data.sellerWorker?.id);
        this.sellerResourceId = String(this.data.resourceId);
        this.deliveryAddressId = String(this.data.deliveryAddressId ?? this.getFirstDeliveryAddressId());


        this.updateWorkers();
        this.updateDeliveryAddresses();
    }
    updateWorkers() {
        this.workers = this.data.workers.filter(
            (worker) => !this.sellerResourceId || worker.resources.includes(+this.sellerResourceId)
        );
    }

    updateDeliveryAddresses() {
        this.resourceDeliveryAddresses = this.getDeliveryAddresses();

        if (!this.resourceDeliveryAddresses.some(el => +el.id === +this.deliveryAddressId)) {
            this.setDeliveryAddress(String(this.getFirstDeliveryAddressId()));
        }
    }

    changeSellerWorker(sellerWorkerId: number) {
        this.sellerWorkerId = sellerWorkerId;
        this.data.sellerWorker = (this.data.workers || []).find((w) => w.id === +sellerWorkerId);
    }
    changeSellerResource(sellerResourceId: number) {
        this.sellerResourceId = sellerResourceId;
        this.updateWorkers();
        this.updateDeliveryAddresses();
    }

    setDeliveryAddress(deliveryAddressId: string) {
        this.deliveryAddressId = deliveryAddressId;
    }

    getRegion(countryId: string, regionId: number) {
        return this.countriesService
            .getRegions(countryId)
            .find((region) => Number(region.id) === Number(regionId));
    }

    getCountry(countryId: string) {
        return this.countriesService.getCountry(countryId);
    }

    getResources() {
        return this.data.resources;
    }

    canResourceChange() {
        return this.data.sellerWorker.person?.user?.id === this.configService.user.user.id || this.data.canQuotesSellerChange;
    }

    getDeliveryAddresses() {
        if (this.sellerResourceId != -1) {
            const department = this.data.resources.find(
                (r) => r.id === +this.sellerResourceId
            );
            if (department?.deliveryAddresses) {
                return department?.deliveryAddresses;
            } else {
                return [];
            }
        }
        return this.data.seller?.addresses.filter(el => Array.isArray(el?.contactFunctions) && el.contactFunctions?.includes('delivery'));
    }

    getFirstDeliveryAddressId(){
        const deliveryAddresses = this.getDeliveryAddresses();
        if (deliveryAddresses.length > 0) {
            return deliveryAddresses[0].id;
        }
        return 0;
    }

    save() {
        const deliveryAddress = this.getDeliveryAddresses().find(el => +el.id === +this.deliveryAddressId);
        this.dialogRef.close({
            sellerWorker: this.data.sellerWorker,
            resourceId: +this.sellerResourceId,
            deliveryAddressId: +this.deliveryAddressId,
            deliveryAddress,
        });
    }

    close() {
        this.dialogRef.close();
    }
}
